import { isTestEnv } from '../isTestEnv/isTestEnv';

export const isBrowserEnv = typeof window !== 'undefined' && !isTestEnv;
